import { connect } from "react-redux";
import React from "react";
import { withRouter } from "react-router";
import clsx from "clsx";

const DashboardCountCard = ({
  count,
  title,
  icon,
  variant = "teal",
  onClick,
  disabled = false
}) => {
  return (
    <div
      role="button"
      className={clsx(
        "gt-stat-card",
        `gt-stat-card--${variant}`,
        disabled && "divDisabled"
      )}
      onClick={disabled ? undefined : onClick}
    >
      {icon && (
        <div className="gt-stat-card__icon">
          <i className={icon} />
        </div>
      )}
      <div className="gt-stat-card__content">
        <div className="gt-stat-card__label">{title || "-"}</div>
        <div className="gt-stat-card__value">
          {count != null && count !== "" ? count : "-"}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, withRouter, null)(DashboardCountCard);
